import { createSlice } from "@reduxjs/toolkit";

const generalSlice = createSlice({
  name: "general",
  initialState: {
    loginLoaded: false,
    isDrawerMenuOpen: false,
    currentPage: "dashboard",
    adminCurrentTab: "employees",
    superAdminCurrentTab: "admin-roles",
    approverCurrentTab: "tr-local",
    spectatorCurrentTab: "tr-local",
    trCurrentTab: "tr-local",
    ebullCurrentTab: null, // This should be id
    dashboardCurrentTab: "dashboard",
    fsrAdminCurrentTab: "all-fsr",
    bulletins: [],
    dataView: "table",
    maintenanceEnabled: false,
    maintenanceBlocked: false,
  },
  reducers: {
    showPopup: (state, action) => {
      const popupKey = action.payload;
      state[popupKey] = true;
    },
    hidePopup: (state, action) => {
      const popupKey = action.payload;
      state[popupKey] = false;
    },
    toggleMenuDrawer: (state) => {
      state.isDrawerMenuOpen = !state.isDrawerMenuOpen;
    },
    openMenuDrawer: (state) => {
      state.isDrawerMenuOpen = true;
    },
    closeMenuDrawer: (state) => {
      state.isDrawerMenuOpen = false;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setAdminTab: (state, action) => {
      state.adminCurrentTab = action.payload;
    },
    setTrTab: (state, action) => {
      state.trCurrentTab = action.payload;
    },
    setApproverTab: (state, action) => {
      state.approverCurrentTab = action.payload;
    },
    setEbullTab: (state, action) => {
      state.ebullCurrentTab = action.payload;
    },
    setSpectatorTab: (state, action) => {
      state.spectatorCurrentTab = action.payload;
    },
    setDashTab: (state, action) => {
      state.dashboardCurrentTab = action.payload;
    },
    setSuperAdminTab: (state, action) => {
      state.superAdminCurrentTab = action.payload;
    },
    setFsrAdminTab: (state, action) => {
      state.fsrAdminCurrentTab = action.payload;
    },
    setLoginLoaded: (state, action) => {
      state.loginLoaded = action.payload;
    },
    setBulletins: (state, action) => {
      state.bulletins = action.payload;
    },

    setViewMode: (state, action) => {
      state.dataView = action.payload === "card" ? "card" : "table";
    },
    toggleViewMode: (state) => {
      state.dataView = state.dataView === "table" ? "card" : "table";
    },
    setMaintenanceEnabled: (state, action) => {
      state.maintenanceEnabled = action.payload;
    },
    setMaintenanceBlocked: (state, action) => {
      state.maintenanceBlocked = action.payload;
    },
  },
  devTools: true,
});

export const {
  showPopup,
  hidePopup,
  toggleMenuDrawer,
  openMenuDrawer,
  closeMenuDrawer,
  setPage,
  setAdminTab,
  setTrTab,
  setApproverTab,
  setEbullTab,
  setSpectatorTab,
  setDashTab,
  setSuperAdminTab,
  setFsrAdminTab,
  setLoginLoaded,
  setBulletins,
  setViewMode,
  toggleViewMode,
  setMaintenanceEnabled,
  setMaintenanceBlocked,
} = generalSlice.actions;
export default generalSlice.reducer;
